<template>
  <b-row class="message-page-header">
    <div class="back-to-messagelist" v-on:click="back"><b-icon-chevron-left />話題一覧に戻る</div>
    <div v-if="!isMobile" ref="topic-title" class="topic-title">{{ `話題: ${titleLabel}` }}</div>
    <!-- ツールチップ(タイトル省略時のみ表示) -->
    <b-tooltip
      @show="onTooltipShow($event, 'topic-title')"
      :target="() => $refs['topic-title']"
      :title="titleLabel"
    />
  </b-row>
</template>

<style lang="scss">
.message-page-header {
  height: 50px;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;

  .back-to-messagelist {
    display: flex;
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 32px;
    height: 100%;
    background: #f4f4f4;
    cursor: pointer;
    align-items: center;

    &:hover {
      background-color: rgb(220, 220, 220);
    }
  }

  .topic-title {
    max-width: calc(100% - 182px); // 182pxは「話題に戻る」ボタンの長さ
    margin: auto 8px auto auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<script lang="ts">
import { computed, defineComponent, getCurrentInstance } from "vue";
import type Vue from "vue";
import { useAppStore, useMessageStore } from "@/store";

export default defineComponent({
  name: "message-page-header",
  props: {
    titleLabel: { type: String, default: () => "", required: true },
    domainId: { type: String, default: () => "", required: true }, //!< 所属組織ID
    topicId: { type: String, default: () => "", required: true }, //!< 所属話題ID
  },
  setup(props) {
    // $router / $route / $refs は vue-router / BootstrapVue が生やす（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    const isMobile = computed((): boolean => {
      return useAppStore().isMobile;
    });

    const back = async (): Promise<void> => {
      if (vm?.$router) {
        await useMessageStore().reset({
          domainId: props.domainId,
          topicId: props.topicId,
          messageId: vm.$route.params.messageId,
        });
        useAppStore().setDomainId(props.domainId);
        useAppStore().setTopicId(""); // topicIdのリセット
        vm.$router.push({ path: `/${props.domainId}` });
      }
    };

    // タイトル省略時のツールチップを出すかどうかを判定する
    const onTooltipShow = (bvEvent: Event, id: string): void => {
      const target = vm?.$refs[id];
      if (target instanceof HTMLElement) {
        // webkit-line-clamp で省略された時、offsetHeight < scrollHeigt になる
        const oHeight = target.offsetHeight;
        const sHeight = target.scrollHeight;
        // text-overflow で省略されたとき、offsetWidth < scrollWidth になる
        const oWidth = target.offsetWidth;
        const sWidth = target.scrollWidth;
        if (oHeight < sHeight || oWidth < sWidth) return;
      }
      bvEvent.preventDefault(); // 出さない
    };

    return {
      isMobile,
      back,
      onTooltipShow,
    };
  },
});
</script>
